module.exports = __webpack_public_path__ + "img/familia.35aed6be.png";